import { createSearchParams } from 'react-router-dom';
import { fetchAsync, postAsync } from '../common/fetch';
import {
  ICreateBookingRequest,
  ICreateBookingResponse,
  IHotelAvailability,
  IHotelInfo,
  IHotelReservationInfo,
  ISearchAvailabilityQuery,
  LoyaltyGiftActionType,
} from '../types/hotelTypes';

export const getHotelList = () => fetchAsync<IHotelInfo[]>('/hotels');
export const getHotelById = (hotelId: number | string) => fetchAsync<IHotelInfo>(`/hotels/${hotelId}`);
export const getHotelReservation = (hotelId: number | string, reservationId: number | string) =>
  fetchAsync<IHotelReservationInfo>(`/hotels/${hotelId}/reservation/${reservationId}`);

export const searchAvailability = (hotelId: number | string, query: ISearchAvailabilityQuery) => {
  const queryStr = createSearchParams([
    ['from', query.from],
    ['to', query.to],
    ['priceOption', query.priceOption],
  ]);
  return fetchAsync<IHotelAvailability[]>(`/hotels/${hotelId}/availability?${queryStr}`);
};

export const createBooking = (hotelId: number | string, request: ICreateBookingRequest) => {
  return postAsync<ICreateBookingRequest, ICreateBookingResponse>(`/hotels/${hotelId}/booking`, request);
};

export interface IRedeemLoyaltyGiftRequest {
  thresholdPoints: number;
  actionType: LoyaltyGiftActionType;
  targetRoomTypeId?: number;
  from?: string;
}

export interface IRedeemLoyaltyGiftResponse {
  success: boolean;
  reservationId: number;
  createdReservationId?: number;
}

export const redeemLoyaltyGift = (
  hotelId: number | string,
  reservationId: number | string,
  request: IRedeemLoyaltyGiftRequest,
) =>
  postAsync<IRedeemLoyaltyGiftRequest, IRedeemLoyaltyGiftResponse>(
    `/hotels/${hotelId}/reservation/${reservationId}/loyalty-gifts/redeem`,
    request,
  );
